import { apiClient } from "./http"

export async function getAdmins(token: string) {
  const { data } = await apiClient.get("/admin/admins", {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}
